<script setup lang="ts">

    import { RouterView } from 'vue-router';
    import ToastVue from '../toast/toast.vue';

</script>

<template>

    <RouterView></RouterView>
    <ToastVue></ToastVue>

</template>

<style lang="scss">

    :root {
        font-family: "DM Sans", sans-serif;
        font-weight: 200;
        color-scheme: light dark;
        background: hsl(0, 0%, 92%);
        color: hsl(0, 0, 0);
        font-synthesis: none;
        text-rendering: optimizeLegibility;
        -webkit-font-smoothing: antialiased;
        // -moz-osx-font-smoothing: grayscale;
        height: 100%;
    }

    button {
        font-family: "DM Sans", sans-serif;
    }

    body {
        margin: 0;
        padding: 0;
        height: 100%;
    }

    #app {
        position: relative;
        height: 100%;
        overflow: hidden;
    }

</style>
